import React,{memo} from 'react';
import Buttons from '../../../../Components/UI/Buttons';


const SectionFormHeader = ({title,secId,pageType=null,isQuickCreate=false,...props})=>{
    let headerClass = 'card-header cursor-pointer sectionHeader pl-1 p-2 position-relative';
    if(isQuickCreate===true){
        return false
        headerClass = 'card-header sectionHeader pl-1 p-2 position-relative bg-transparent';
    }//card-header p-0 bg-transparent no-bd border-bottom mb-2
    return(
        <div className={headerClass}>
            <div className={`card-title d-flex align-items-center justify-content-between`} style={{position:'relative'}} id={'card'+secId} data-toggle="collapse" href={`#${secId}`}> 
                {(pageType==='view')?
                    <>{title}</>
                :<h6 className="mb-0"> {title} </h6>}  
                <div className="span-mode"></div>
            </div>
            <div className='d-flex align-items-center justify-content-center' style={{position:'absolute' , top:'3px' , left:'0' , right:'0' , margin:'0 auto'}} >
                {(pageType==='form' )&&<> 
                          <div className='btn-group' > 
                          <Buttons buttonList={props.buttonList} />
                          </div>
                    </>
                  }
            </div>
                  
        </div>
    )
}
export default memo(SectionFormHeader);